import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { MapPin, X, ArrowRight } from 'lucide-react';
import { UNITS } from './data';
import { openWhatsApp } from './whatsapp';

type OpenPicker = (source: string) => void;

const UnitPickerContext = createContext<OpenPicker>(() => undefined);

export const useUnitPicker = (): OpenPicker => useContext(UnitPickerContext);

export const UnitPickerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [source, setSource] = useState<string | null>(null);

  const open = useCallback<OpenPicker>((origin) => setSource(origin), []);
  const close = () => setSource(null);

  useEffect(() => {
    if (!source) return;
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && setSource(null);
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [source]);

  return (
    <UnitPickerContext.Provider value={open}>
      {children}
      {source && (
        <div className="lp-picker-overlay" onClick={close} role="presentation">
          <div
            className="lp-picker"
            role="dialog"
            aria-modal="true"
            aria-labelledby="lp-picker-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button className="lp-picker-close" onClick={close} aria-label="Fechar">
              <X size={20} />
            </button>
            <span className="lp-eyebrow">Aula experimental grátis</span>
            <h3 id="lp-picker-title">Qual unidade fica melhor para você?</h3>
            <div className="lp-picker-options">
              {UNITS.map((unit) => (
                <button
                  key={unit.id}
                  className="lp-picker-option"
                  onClick={() => {
                    openWhatsApp(unit, source);
                    close();
                  }}
                >
                  <img src={unit.photos[0]} alt="" />
                  <span className="lp-picker-option-text">
                    <strong>{unit.neighborhood}</strong>
                    <small>
                      <MapPin size={14} /> {unit.address}
                    </small>
                  </span>
                  <ArrowRight className="lp-picker-arrow" size={20} />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </UnitPickerContext.Provider>
  );
};
